export var ResourceType;
(function (ResourceType) {
    ResourceType[ResourceType["Authorize"] = 1] = "Authorize";
    ResourceType[ResourceType["Data"] = 2] = "Data";
    ResourceType[ResourceType["Pipe"] = 3] = "Pipe";
    ResourceType[ResourceType["Solution"] = 4] = "Solution";
    ResourceType[ResourceType["Blueprint"] = 5] = "Blueprint";
    ResourceType[ResourceType["Dashboard"] = 6] = "Dashboard";
    ResourceType[ResourceType["Module"] = 7] = "Module";
    ResourceType[ResourceType["UnitTestData"] = 8] = "UnitTestData";
})(ResourceType || (ResourceType = {}));
//# sourceMappingURL=resourceType.js.map